import { Center, Icon } from '@tempots/beatui'

export function BigLoader() {
  return Center({}, Icon({ icon: 'line-md:loading-twotone-loop', size: 'xl' }))
}
